import ContinueToPaymentButton from './ContinueToPaymentButton';

export default ContinueToPaymentButton;
